<template>
    <div>
        <v-container fluid class="pa-0 px-3">
            <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0;">
                <h2 class="pb-5">Review Enquiry</h2>
            </div>
            <div class="se-main-card">
            <v-row class="mb-3">
                <div class="pt-2">
                    <v-row>
                        <v-col>
                            <v-btn 
                                color="warning" 
                                style="width: 100px"
                                @click="backHandler" 
                                > 
                                {{$t('button.back')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-row>

            <!-- General -->
            <v-row v-if="viewby == null">
                <v-col cols="12">
                    <v-card elevation="5" outlined class="mb-4">
                    <apexchart
                        v-if="!loading && hide"
                        id="chart"
                        type="bar"
                        width="100%"
                        :options="chartOptionsGeneral"
                        :series="seriesGeneral"
                    />
                    </v-card>
                </v-col>
            </v-row>

            <!-- By Company -->
            <v-row v-else-if="viewby == 'Company'">
                <v-col
                    v-for="company in companyList"
                    :key="company.compnyname"
                    cols="12"
                    md="6"
                >
                    <v-card elevation="5" outlined class="mb-4">
                    <apexchart
                        v-if="!loading && hide && companyCharts[company.compnyname]"
                        id="chart"
                        type="bar"
                        width="100%"
                        :options="companyCharts[company.compnyname].options"
                        :series="companyCharts[company.compnyname].series"
                    />
                    </v-card>
                </v-col>
            </v-row>

            <!-- By Department -->
            <v-row v-else-if="viewby == 'Department'">
                <v-col
                    v-for="department in departmentList"
                    :key="department.deptname"
                    cols="12"
                    md="6"
                >
                    <v-card elevation="5" outlined class="mb-4">
                    <apexchart
                        v-if="!loading && hide && departmentCharts[department.deptname]"
                        id="chart"
                        type="bar"
                        width="100%"
                        :options="departmentCharts[department.deptname].options"
                        :series="departmentCharts[department.deptname].series"
                    />
                    </v-card>
                </v-col>
            </v-row>

            <!-- By Branch -->
            <v-row v-else-if="viewby == 'Branch'">
                <v-col
                    v-for="branch in branchList"
                    :key="branch.brchname"
                    cols="12"
                    md="6"
                >
                    <v-card elevation="5" outlined class="mb-4">
                    <apexchart
                        v-if="!loading && hide && branchCharts[branch.brchname]"
                        id="chart"
                        type="bar"
                        width="100%"
                        :options="branchCharts[branch.brchname].options"
                        :series="branchCharts[branch.brchname].series"
                    />
                    </v-card>
                </v-col>
            </v-row>

            <!-- By Section -->
            <v-row v-else-if="viewby == 'Section'">
                <v-col
                    v-for="section in sectionList"
                    :key="section.sectioname"
                    cols="12"
                    md="6"
                >
                    <v-card elevation="5" outlined class="mb-4">
                    <apexchart
                        v-if="!loading && hide && sectionCharts[section.sectioname]"
                        id="chart"
                        type="bar"
                        width="100%"
                        :options="sectionCharts[section.sectioname].options"
                        :series="sectionCharts[section.sectioname].series"
                    />
                    </v-card>
                </v-col>
            </v-row>

            <!-- Shared full-width table (shown after any bar click) -->
            <v-row v-if="!hidetable">
                <v-col cols="12">
                    <v-toolbar>
                        <v-toolbar-title style="height: 50px; margin-top: 20px; margin-left:20px" class="textBlue">
                            {{ title }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <div style="display:flex;align-items:center;gap:8px;margin-right:8px;">
                        <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF(currentType, currentKey)" title="Export PDF"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>PDF</button>
                        <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV(currentType, currentKey)" title="Export CSV"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>CSV</button>
                        </div>
                    </v-toolbar>
                    <div style="overflow-x: auto; width: 100%;">
                        <v-data-table
                            :headers="headers"
                            :items="sharedTableData"
                            class="elevation-1"
                            style="margin-top: 0;"
                        >
                        </v-data-table>
                    </div>
                </v-col>
            </v-row>

            </div><!-- end se-main-card -->
        </v-container>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import jsPDF from 'jspdf'
import 'jspdf-autotable' 
import moment from 'moment';

export default {
    components: {
        'apexchart': VueApexCharts,
    },

    data() {

        return {
            publicPath: process.env.BASE_URL,
            bar_data_returned: [],
           
            chartOptionsGeneral: {
                chart: {
                    id: 'general-chart',
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                        const barIndex = config.dataPointIndex;
                        const barName = chartContext.w.globals.labels[barIndex];
                        console.log("dataPointSelection - General", event, chartContext, config);
                        this.getStaffDetails(null, null, null, null, barName);
                    },
                    },
                },
                title: {
                    text: this.$t('reviewenquiryanalysis.reviewexerciseanalysis') + this.reviewexercisename, 
                    align: 'center',
                    margin: 10,
                    style: {
                        fontsize: '16px',
                        color: ' #004080',
                        fontweight: 'light',
                        fontfamily: 'Lato-Bold'
                    },
                },
                subtitle: {
                    text: this.$t('reportheadcountanalysis.clickatrespectivebarstafflist'), 
                    align: 'center',
                    style: {
                        fontsize: '100px',
                        color: 'grey',
                        fontfamily: 'Lato-Bold'
                    },
                },
                legend: {
                    show: false,
                },
                plotOptions: {
                    bar: {
                        distributed: true
                    }
                },
                xaxis: {
                    categories: []
                }
            },
            seriesGeneral: [{
                name: 'No. of Staff',
                data: []
            }],

            //By company 
            chartOptionsCompany: {
                chart: {
                    id: 'company-chart',
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                        this.getStaffDetails(config.dataPointIndex);
                    },
                    },
                },
                title: {
                    text: this.$t('reviewenquiryanalysis.reviewexercisebycompany') + this.reviewexercisename, 
                    align: 'center',
                    margin: 10,
                    style: {
                        fontsize: '16px',
                        color: ' #004080',
                        fontweight: 'light',
                        fontfamily: 'Lato-Bold'
                    },
                },
                subtitle: {
                    text: this.$t('reportheadcountanalysis.clickatrespectivebarstafflist'), 
                    align: 'center',
                    style: {
                        fontsize: '100px',
                        color: 'grey',
                        fontfamily: 'Lato-Bold'
                    },
                },
                legend: {
                    show: false,
                },
                plotOptions: {
                    bar: {
                        distributed: true
                    }
                },
                xaxis: {
                    categories: []
                }
            },
            seriesCompany: [{
                name: 'No. of Staff',
                data: []
            }],

            //By dept. 
            chartOptionsDepartment: {
                chart: {
                id: "dept-bar",
                events: {
                        dataPointSelection: (event, chartContext, config) => {
                        this.getStaffDetails(config.dataPointIndex);
                    },
                    },
                
                },
                title: {
                    text: this.$t('reviewenquiryanalysis.reviewexercisebydept') + this.reviewexercisename, 
                    align: 'center',
                    margin: 10,
                    style: {
                        fontsize: '16px',
                        color: ' #004080',
                        fontweight: 'light',
                        fontfamily: 'Lato-Bold'
                    },
                },
                subtitle: {
                    text: this.$t('reportheadcountanalysis.clickatrespectivebarstafflist'), 
                    align: 'center',
                    style: {
                        fontsize: '100px',
                        color: 'grey',
                        fontfamily: 'Lato-Bold'
                    },
                },
                legend: {
                    show: false,
                },
                plotOptions: {
                    bar: {
                        distributed: true,
                    }
                },
                xaxis: {
                    categories: []
                },
            },
            seriesDepartment: [{
                data: [],
                name: 'No. of Staff',
            }],

            //By branch 
            chartOptionsBranch: {
                chart: {
                id: "branch-bar",
                events: {
                        dataPointSelection: (event, chartContext, config) => {
                        this.getStaffDetails(config.dataPointIndex);
                    },
                    },
                
                },
                title: {
                    text: this.$t('reviewenquiryanalysis.reviewexercisebybranch') + this.reviewexercisename, 
                    align: 'center',
                    margin: 10,
                    style: {
                        fontsize: '16px',
                        color: ' #004080',
                        fontweight: 'light',
                        fontfamily: 'Lato-Bold'
                    },
                },
                subtitle: {
                    text: this.$t('reportheadcountanalysis.clickatrespectivebarstafflist'), 
                    align: 'center',
                    style: {
                        fontsize: '100px',
                        color: 'grey',
                        fontfamily: 'Lato-Bold'
                    },
                },
                legend: {
                    show: false,
                },
                plotOptions: {
                    bar: {
                        distributed: true,
                    }
                },
                xaxis: {
                    categories: []
                },
            },
            seriesBranch: [{
                data: [],
                name: 'No. of Staff',
            }],

            //By section
            chartOptionsSection: {
                chart: {
                id: "section-bar",
                events: {
                        dataPointSelection: (event, chartContext, config) => {
                        this.getStaffDetails(config.dataPointIndex);
                    },
                    },
                
                },
                title: {
                    text: this.$t('reviewenquiryanalysis.reviewexercisebysection') + this.reviewexercisename, 
                    align: 'center',
                    margin: 10,
                    style: {
                        fontsize: '16px',
                        color: ' #004080',
                        fontweight: 'light',
                        fontfamily: 'Lato-Bold'
                    },
                },
                subtitle: {
                    text: this.$t('reportheadcountanalysis.clickatrespectivebarstafflist'), 
                    align: 'center',
                    style: {
                        fontsize: '100px',
                        color: 'grey',
                        fontfamily: 'Lato-Bold'
                    },
                },
                legend: {
                    show: false,
                },
                plotOptions: {
                    bar: {
                        distributed: true,
                    }
                },
                xaxis: {
                    categories: []
                },
            },
            seriesSection: [{
                data: [],
                name: 'No. of Staff',
            }],

            //table headers
            headers: [
                //Staff
                {text: this.$t('columns.staffcode'), value:"rdstaffcode", width: '200px' },
                {text: this.$t('columns.name'), value:"rdstaffname", width: '200px' }, 
                {text: this.$t('columns.startdate'), value:"rdstartdate", width: '200px' },
                {text: this.$t('columns.enddate'), value:"rdenddate", width: '200px' },
                {text: this.$t('columns.status'), value:"rdstatus", width: '200px' },
                {text: this.$t('Setupratingscaleset.score'), value:"rdscore", width: '200px' },
                {text: this.$t('Setuprankingset.rank'), value:"rdrank", width: '200px'},
                {text: this.$t('columns.company'), value:"rdcompnyname", width: '200px'},
                {text: this.$t('columns.branch'), value:"rdbrchname", width: '200px'},
                {text: this.$t('columns.department'), value:"rddeptname", width: '200px'},
                {text: this.$t('columns.section'), value:"rdsectioname", width: '200px'},
                {text: this.$t('columns.unit'), value:"rdunitname", width: '200px'},
                {text: this.$t('columns.grade'), value:"rdgrddesc", width: '200px'},
                {text: this.$t('columns.position'), value:"rdposdesc", width: '200px'},
                //Reviewer
                {text: this.$t('appraisalrecord.reviewercode(staffcode)'), value:"rsrstaffcode", width: '200px'},
                {text: this.$t('appraisalrecord.reviewername'), value:"rsrstaffname", width: '200px'}, 
                {text: this.$t('columns.startdate'), value:"rsrstartdate", width: '200px'},
                {text: this.$t('columns.enddate'), value:"rsrenddate", width: '200px'},
                {text: this.$t('columns.status'), value:"rsrstatus", width: '200px'},
                {text: this.$t('pmreviewexercise.reviewertype'), value:"reviewertypename", width: '200px'},
                {text: this.$t('appraisalrecord.factor'), value:"factor", width: '200px'},
                {text: this.$t('Setupratingscaleset.score'), value:"rsrscore", width: '200px'},
                {text: this.$t('columns.company'), value:"rsrcompnyname", width: '200px'},
                {text: this.$t('columns.branch'), value:"rsrbrchname", width: '200px'},
                {text: this.$t('columns.department'), value:"rsrdeptname", width: '200px'},
                {text: this.$t('columns.section'), value:"rsrsectioname", width: '200px'},
                {text: this.$t('columns.unit'), value:"rsrunitname", width: '200px'},
                {text: this.$t('columns.grade'), value:"rsrgrddesc", width: '200px'},
                {text: this.$t('columns.position'), value:"rsrposdesc", width: '200px'},
            ],

            //load bar chart and error message variable
            isErr: false,
            loading: true,

            //hide or show charts & tables variables
            hide : true,
            hidetable: true,

            //title for print to pdf 
            title: this.$t('reportheadcountanalysis.stafflistfor'), 

            viewby: '',
            companyList: [],
            companyCharts: {},
            departmentList: [],
            departmentCharts: {},
            branchList: [],
            branchCharts: {},
            sectionList: [],
            sectionCharts: {},
            staffDetailsGeneral: [],
            staffDetailsByCompany: {},
            staffDetailsByDepartment: {},
            staffDetailsByBranch: {},
            staffDetailsBySection: {},
            sharedTableData: [],
            currentType: null,
            currentKey: null,
        }

    },

    
    methods: {
        generalchart(){
            const vm = this; 

            vm.chartOptionsGeneral = {
                ...vm.chartOptionsGeneral, 
                ...{
                    title: {
                        text: this.$t('reviewenquiryanalysis.reviewexerciseanalysis') + vm.reviewexercisename, 
                        align: 'center',
                        margin: 10,
                        style: {
                            fontsize: '16px',
                            color: ' #004080'
                        }, 
                    }, 
                    
                }
            };

            // get data for bar chart - general distribution
            this.$store.dispatch('get', {url: "/reviewenquiry/count/" + vm.reviewexerciseid})
            .then(res => {
                vm.bar_data_returned = res.data.rec;
                let apiData = res.data.rec; 

                apiData.forEach(element => {
                    vm.chartOptionsGeneral.xaxis.categories.push(element.rank)
                    vm.seriesGeneral[0].data.push(element.total_in_rank)
                });

                vm.loading = false; 
            })
            .catch(err => {
                //error - unsucessfull request
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            });
        },

        async companychart() {
            const vm = this;

            for (const company of vm.companyList) {
                // Initialize options & series
                vm.$set(vm.companyCharts, company.compnyname, {
                    options: {
                        ...vm.chartOptionsCompany,
                        chart: {
                            id: 'company-chart-' + company.compnyname,
                            events: {
                                dataPointSelection: (event, chartContext, config) => {
                                    const barIndex = config.dataPointIndex;
                                    const barName = chartContext.w.globals.labels[barIndex];
                                    console.log('Clicked company:', company.compnyname);
                                    console.log('Clicked bar index:', config.dataPointIndex);
                                    this.getStaffDetails(company.compnyname, null, null, null, barName);
                                }
                            }
                        },
                        title: {
                            text: this.$t('reviewenquiryanalysis.reviewexercisebycompany') + " " + company.compnyname,
                            align: 'center',
                            margin: 10,
                            style: { fontSize: '16px', color: '#004080' }
                        },
                        xaxis: {    
                            categories: [],
                            title: {
                                text: 'Rank',  // your X-axis label
                                style: { fontSize: '14px', color: '#004080' }
                            }
                        },
                        yaxis: {
                            title: {
                                text: 'Number of Staff', // your Y-axis label
                                style: { fontSize: '14px', color: '#004080' }
                            }
                        }
                    },
                    series: [{ name: 'No. of Staff', data: [] }]
                });

                // Await the API call for this company
                try {
                    const res = await this.$store.dispatch('get', { url: "/reviewenquiry/countbycompany/" + vm.reviewexerciseid + "/" + company.compnyname });
                    const apiData = res.data.rec;
                    apiData.forEach(el => {
                        vm.companyCharts[company.compnyname].options.xaxis.categories.push(el.rank);
                        vm.companyCharts[company.compnyname].series[0].data.push(el.total_in_rank);
                    });
                } catch (err) {
                    this.isErr = true;
                    this.errMsg = err;
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            }
        },

        async departmentchart() {
            const vm = this;

            for (const department of vm.departmentList) {
                // Initialize options & series
                vm.$set(vm.departmentCharts, department.deptname, {
                    options: {
                        ...vm.chartOptionsDepartment,
                        chart: {
                            id: 'department-chart-' + department.deptname,
                            events: {
                                dataPointSelection: (event, chartContext, config) => {
                                    const barIndex = config.dataPointIndex;
                                    const barName = chartContext.w.globals.labels[barIndex];
                                    console.log('Clicked department:', department.deptname);
                                    console.log('Clicked bar index:', barIndex);
                                    console.log('Clicked bar name:', barName);
                                    this.getStaffDetails(null, department.deptname, null, null, barName);
                                }
                            }
                        },
                        title: {
                            text: this.$t('reviewenquiryanalysis.reviewexercisebydept') + " " + department.deptname,
                            align: 'center',
                            margin: 10,
                            style: { fontSize: '16px', color: '#004080' }
                        },
                        xaxis: {    
                            categories: [],
                            title: {
                                text: 'Rank',  // your X-axis label
                                style: { fontSize: '14px', color: '#004080' }
                            }
                        },
                        yaxis: {
                            title: {
                                text: 'Number of Staff', // your Y-axis label
                                style: { fontSize: '14px', color: '#004080' }
                            }
                        }
                    },
                    series: [{ name: 'No. of Staff', data: [] }]
                });

                // Await the API call for this department
                try {
                    const res = await this.$store.dispatch('get', { url: "/reviewenquiry/countbydept/" + vm.reviewexerciseid + "/" + department.deptname });
                    const apiData = res.data.rec;
                    apiData.forEach(el => {
                        vm.departmentCharts[department.deptname].options.xaxis.categories.push(el.rank);
                        vm.departmentCharts[department.deptname].series[0].data.push(el.total_in_rank);
                    });
                } catch (err) {
                    this.isErr = true;
                    this.errMsg = err;
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            }
        },

        async branchchart() {
            const vm = this;

            for (const branch of vm.branchList) {
                // Initialize options & series
                vm.$set(vm.branchCharts, branch.brchname, {
                    options: {
                        ...vm.chartOptionsBranch,
                        chart: {
                            id: 'branch-chart-' + branch.brchname,
                            events: {
                                dataPointSelection: (event, chartContext, config) => {
                                    const barIndex = config.dataPointIndex;
                                    const barName = chartContext.w.globals.labels[barIndex];
                                    console.log('Clicked branch:', branch.brchname);
                                    console.log('Clicked bar index:', config.dataPointIndex);
                                    this.getStaffDetails(null, null, branch.brchname, null, barName);
                                }
                            }
                        },
                        title: {
                            text: this.$t('reviewenquiryanalysis.reviewexercisebybranch') + " " + branch.brchname,
                            align: 'center',
                            margin: 10,
                            style: { fontSize: '16px', color: '#004080' }
                        },
                        xaxis: {    
                            categories: [],
                            title: {
                                text: 'Rank',  // your X-axis label
                                style: { fontSize: '14px', color: '#004080' }
                            }
                        },
                        yaxis: {
                            title: {
                                text: 'Number of Staff', // your Y-axis label
                                style: { fontSize: '14px', color: '#004080' }
                            }
                        }
                    },
                    series: [{ name: 'No. of Staff', data: [] }]
                });

                // Await the API call for this department
                try {
                    const res = await this.$store.dispatch('get', { url: "/reviewenquiry/countbybranch/" + vm.reviewexerciseid + "/" + branch.brchname });
                    const apiData = res.data.rec;
                    apiData.forEach(el => {
                        vm.branchCharts[branch.brchname].options.xaxis.categories.push(el.rank);
                        vm.branchCharts[branch.brchname].series[0].data.push(el.total_in_rank);
                    });
                } catch (err) {
                    this.isErr = true;
                    this.errMsg = err;
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            }
        },

        async sectionchart() {
            const vm = this;

            for (const section of vm.sectionList) {
                // Initialize options & series
                vm.$set(vm.sectionCharts, section.sectioname, {
                    options: {
                        ...vm.chartOptionsSection,
                        chart: {
                            id: 'section-chart-' + section.sectioname,
                            events: {
                                dataPointSelection: (event, chartContext, config) => {
                                    const barIndex = config.dataPointIndex;
                                    const barName = chartContext.w.globals.labels[barIndex];
                                    console.log('Clicked section:', section.sectioname);
                                    console.log('Clicked bar index:', config.dataPointIndex);
                                    this.getStaffDetails(null, null, null, section.sectioname, barName);
                                }
                            }
                        },
                        title: {
                            text: this.$t('reviewenquiryanalysis.reviewexercisebysection') + " " + section.sectioname,
                            align: 'center',
                            margin: 10,
                            style: { fontSize: '16px', color: '#004080' }
                        },
                        xaxis: {    
                            categories: [],
                            title: {
                                text: 'Rank',  // your X-axis label
                                style: { fontSize: '14px', color: '#004080' }
                            }
                        },
                        yaxis: {
                            title: {
                                text: 'Number of Staff', // your Y-axis label
                                style: { fontSize: '14px', color: '#004080' }
                            }
                        }
                    },
                    series: [{ name: 'No. of Staff', data: [] }]
                });

                // Await the API call for this department
                try {
                    const res = await this.$store.dispatch('get', { url: "/reviewenquiry/countbysection/" + vm.reviewexerciseid + "/" + section.sectioname });
                    const apiData = res.data.rec;
                    apiData.forEach(el => {
                        vm.sectionCharts[section.sectioname].options.xaxis.categories.push(el.rank);
                        vm.sectionCharts[section.sectioname].series[0].data.push(el.total_in_rank);
                    });
                } catch (err) {
                    this.isErr = true;
                    this.errMsg = err;
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            }
        },

        //Might use in future case, so don't remove
        //drill down to dept chart
        // drilldown(dataPointIndex){
        //     try {
        //         this.compnyid = this.bar_data_returned[dataPointIndex].companyid;
        //         this.compnyname = this.bar_data_returned[dataPointIndex].compnyname;

        //         const vm = this;

        //         vm.chartOptionsDepartment = {
        //             ...vm.chartOptionsDepartment, 
        //             ...{
        //                 title: {
        //                     text: this.$t('reviewenquiryanalysis.reviewexercisebydept') + this.reviewexercisename, 
        //                     align: 'center',
        //                     margin: 10,
        //                     style: {
        //                         fontsize: '16px',
        //                         color: 'grey'
        //                     }, 
        //                 }, 
        //                 subtitle: {
        //                     text: '' + this.compnyname,
        //                     align: 'center',
        //                     margin: 10,
        //                     style: {
        //                         fontsize: '100px',
        //                         color: ' #004080'
        //                     }, 
        //                 }
        //             }
        //         };

        //         this.$store.dispatch('get', {url: "/reviewenquiry/countbydept/" + vm.reviewexerciseid + "/" + vm.compnyname})
        //         .then(res => {
        //             vm.dept_data_returned = res.data.rec;
        //             console.log("data returned", res.data.rec)
        //             let apiData = res.data.rec; 

        //             apiData.forEach(element => {
        //                 vm.chartOptionsDepartment.xaxis.categories.push(element.deptname)
        //                 vm.seriesDepartment[0].data.push(element.total_department)
        //             });
                
        //             vm.hide = false;
        //             vm.loading = false; 
        //         })
        //         .catch(err => {
        //             //error - unsucessfull request
        //             this.isErr = true;
        //             this.errMsg = err;
        //             this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
        //         });
        //     } catch (err) {
        //         this.err = err.message;
        //     }
        // },

        getStaffDetails(compnyname = null, deptname = null, brchname = null, sectioname = null, rank) {
            const vm = this;

            console.log("RANK", rank);

            if (rank == 'UNRANKED'){
                rank = null;
            }

            const data = {};
            if (compnyname) {
                data.compnyname = compnyname;
            }
            if (deptname) {
                data.deptname = deptname;
            }
            if (brchname) {
                data.brchname = brchname;
            }
            if (sectioname) {
                data.sectioname = sectioname;
            }

            data.rank = rank;

            this.$store.dispatch('post', {url: "/reviewenquiry/staffdetails/" + vm.reviewexerciseid, payload: data})
            .then(res => {
                const list = res.data.rec;
                for (let i = 0; i < list.length; i++) {
                  if (list[i].rdstartdate) {
                        list[i].rdstartdate = moment(list[i].rdstartdate).format('YYYY-MM-DD');
                  }
                  if (list[i].rdenddate) {
                        list[i].rdenddate = moment(list[i].rdenddate).format('YYYY-MM-DD');
                  }
                  if (list[i].rsrstartdate) {
                        list[i].rsrstartdate = moment(list[i].rsrstartdate).format('YYYY-MM-DD');
                  }
                  if (list[i].rsrenddate) {
                        list[i].rsrenddate = moment(list[i].rsrenddate).format('YYYY-MM-DD');
                  }
               }

                if (compnyname) {
                    vm.$set(vm.staffDetailsByCompany, compnyname, list);
                    vm.$set(vm.companyCharts[compnyname], 'showTable', true);
                    vm.currentType = 'Company';
                    vm.currentKey = compnyname;
                } else if (deptname) {
                    vm.$set(vm.staffDetailsByDepartment, deptname, list);
                    vm.$set(vm.departmentCharts[deptname], 'showTable', true);
                    vm.currentType = 'Department';
                    vm.currentKey = deptname;
                } else if (brchname) {
                    vm.$set(vm.staffDetailsByBranch, brchname, list);
                    vm.$set(vm.branchCharts[brchname], 'showTable', true);
                    vm.currentType = 'Branch';
                    vm.currentKey = brchname;
                } else if (sectioname) {
                    vm.$set(vm.staffDetailsBySection, sectioname, list);
                    vm.$set(vm.sectionCharts[sectioname], 'showTable', true);
                    vm.currentType = 'Section';
                    vm.currentKey = sectioname;
                } else {
                    vm.staffDetailsGeneral = list;
                    vm.currentType = 'General';
                    vm.currentKey = null;
                }
                vm.sharedTableData = list;

                vm.title = this.$t('reportheadcountanalysis.stafflistfor') + vm.reviewexercisename; 

                //show table 
                vm.hidetable = false;
                vm.loading = false; 
            })
            .catch(err => {
                //error - unsucessfull request
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            });
        },

        // functions for print to pdf and export to csv
        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        getCSV(type, key = null) {
            let item = [];

            const sourceMap = {
                General: this.staffDetailsGeneral,
                Company: this.staffDetailsByCompany,
                Department: this.staffDetailsByDepartment,
                Section: this.staffDetailsBySection,
                Branch: this.staffDetailsByBranch
            };

            if (type === 'General') {
                item = sourceMap[type] || [];
            } else {
                item = sourceMap[type]?.[key] || [];
            }

            if (!item.length) return;

            const data = item.map(row => ({
                [this.$t('columns.staffcode')]: row.rdstaffcode,
                [this.$t('columns.name')]: row.rdstaffname,
                [this.$t('columns.startdate')]: row.rdstartdate,
                [this.$t('columns.enddate')]: row.rdenddate,
                [this.$t('columns.status')]: row.rdstats,
                [this.$t('Setupratingscaleset.score')]: row.rdscore,
                [this.$t('Setuprankingset.rank')]: row.rdrank,
                [this.$t('columns.company')]: row.rdcompnyname,
                [this.$t('columns.branch')]: row.rdbrchname,
                [this.$t('columns.department')]: row.rddeptname,
                [this.$t('columns.section')]: row.rdsectioname,
                [this.$t('columns.unit')]: row.rdunitname,
                [this.$t('columns.grade')]: row.rdgrdcode,
                [this.$t('columns.position')]: row.rdposdesc,
                [this.$t('appraisalrecord.reviewercode(staffcode)')]: row.rsrstaffcode,
                [this.$t('appraisalrecord.reviewername')]: row.rsrstaffname,
                [this.$t('columns.startdate')]: row.rsrstartdate,
                [this.$t('columns.enddate')]: row.rsrenddate,
                [this.$t('columns.status')]: row.rsrstatus,
                [this.$t('pmreviewexercise.reviewertype')]: row.reviewertypename,
                [this.$t('appraisalrecord.factor')]: row.factor,
                [this.$t('Setupratingscaleset.score')]: row.rsrscore,
                [this.$t('columns.company')]: row.rsrcompnyname,
                [this.$t('columns.branch')]: row.rsrbrchname,
                [this.$t('columns.department')]: row.rsrdeptname,
                [this.$t('columns.section')]: row.rsrsectioname,
                [this.$t('columns.unit')]: row.rsrunitname,
                [this.$t('columns.grade')]: row.rsrgrdcode,
                [this.$t('columns.position')]: row.rsrposdesc
            }));

            const csvData = this.objectToCSV(data);
            this.download(csvData, `${type}-${key}`);
        },

        printPDF(type, key = null) {
            let item = [];

            const sourceMap = {
                General: this.staffDetailsGeneral,
                Company: this.staffDetailsByCompany,
                Department: this.staffDetailsByDepartment,
                Section: this.staffDetailsBySection,
                Branch: this.staffDetailsByBranch
            };

            if (type === 'General') {
                item = sourceMap[type] || [];
            } else {
                item = sourceMap[type]?.[key] || [];
            }

            if (!item.length) return;

            const doc = new jsPDF({ orientation: 'landscape' });
            // Helper for title
            const title = (part) => 
                `${this.$t('reportheadcountanalysis.stafflistfor')} ${type}` + 
                (type === 'General' ? '' : `: ${key}`) + 
                ` - ${part}`;

            // --- Part 1: Columns up to before reviewer ---
            const head1 = [[
                'No.', // row number
                this.$t('columns.staffcode'),
                this.$t('columns.name'),
                this.$t('columns.startdate'),
                this.$t('columns.enddate'),
                this.$t('columns.status'),
                this.$t('Setupratingscaleset.score'),
                this.$t('Setuprankingset.rank'),
                this.$t('columns.company'),
                this.$t('columns.branch'),
                this.$t('columns.department'),
                this.$t('columns.section'),
                this.$t('columns.unit'),
                this.$t('columns.grade'),
                this.$t('columns.position')
            ]];

            const body1 = item.map((row, index) => [
                index + 1, // count column
                row.rdstaffcode,
                row.rdstaffname,
                row.rdstartdate,
                row.rdenddate,
                row.rdstats,
                row.rdscore,
                row.rdrank,
                row.rdcompnyname,
                row.rdbrchname,
                row.rddeptname,
                row.rdsectioname,
                row.rdunitname,
                row.rdgrdcode,
                row.rdposdesc
            ]);

            doc.text(title('Part 1: Staff Details'), 10, 10);
            doc.autoTable({
                head: head1,
                body: body1,
                startY: 20,
                styles: { fontSize: 6.5, cellPadding: 1 },
                headStyles: { fillColor: [41,128,185], textColor: 255, fontStyle: 'bold' },
                overflow: 'linebreak',
                tableWidth: 'auto'
            });

            // --- Part 2: Columns from reviewer onwards ---
            const head2 = [[
                'No',
                this.$t('columns.staffcode'),
                this.$t('columns.name'),
                this.$t('appraisalrecord.reviewercode(staffcode)'),
                this.$t('appraisalrecord.reviewername'),
                this.$t('columns.startdate'),
                this.$t('columns.enddate'),
                this.$t('columns.status'),
                this.$t('pmreviewexercise.reviewertype'),
                this.$t('appraisalrecord.factor'),
                this.$t('Setupratingscaleset.score'),
                this.$t('columns.company'),
                this.$t('columns.branch'),
                this.$t('columns.department'),
                this.$t('columns.section'),
                this.$t('columns.unit'),
                this.$t('columns.grade'),
                this.$t('columns.position')
            ]];

            const body2 = item.map((row, index) => [
                index + 1, // count column
                row.rdstaffcode,
                row.rdstaffname,
                row.rsrstaffcode,
                row.rsrstaffname,
                row.rsrstartdate,
                row.rsrenddate,
                row.rsrstatus,
                row.reviewertypename,
                row.factor,
                row.rsrscore,
                row.rsrcompnyname,
                row.rsrbrchname,
                row.rsrdeptname,
                row.rsrsectioname,
                row.rsrunitname,
                row.rsrgrdcode,
                row.rsrposdesc
            ]);

            doc.addPage();
            doc.text(title('Part 2: Reviewer Details'), 10, 10);
            doc.autoTable({
                head: head2,
                body: body2,
                startY: 20,
                styles: { fontSize: 6.5, cellPadding: 1 },
                headStyles: { fillColor: [41,128,185], textColor: 255, fontStyle: 'bold' },
                overflow: 'linebreak',
                tableWidth: 'auto'
            });

            doc.save(`${type}${type === 'General' ? '' : `-${key}`}.pdf`);
        },

        backHandler(){
            this.$router.push({name: 'pmreviewenquiry'});
        },

        async loadCompanies() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', { url: "/reviewenquiry/companylist/" + vm.reviewexerciseid });
                vm.companyList = res.data.rec;

                // await the chart generation if companychart is async
                await vm.companychart();

                vm.loading = false;
            } catch (err) {
                // error - unsuccessful request
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async loadDepartments() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', { url: "/reviewenquiry/deptlist/" + vm.reviewexerciseid });
                vm.departmentList = res.data.rec;

                // await the chart generation if departmentchart is async
                await vm.departmentchart();

                vm.loading = false;
            } catch (err) {
                // error - unsuccessful request
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async loadBranches() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', { url: "/reviewenquiry/branchlist/" + vm.reviewexerciseid });
                vm.branchList = res.data.rec;

                // await the chart generation if branchchart is async
                await vm.branchchart();
                vm.loading = false;
            } catch (err) {
                // error - unsuccessful request
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async loadSections() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', { url: "/reviewenquiry/sectionlist/" + vm.reviewexerciseid });
                vm.sectionList = res.data.rec;

                // await the chart generation if sectionchart is async
                await vm.sectionchart();
                vm.loading = false;
            } catch (err) {
                // error - unsuccessful request
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },
    },

    mounted() {
        const vm = this;
        vm.reviewexerciseid = this.$route.params.reviewexerciseid;
        vm.reviewexercisename = this.$route.params.reviewexercisename;
        vm.viewby = this.$route.params.viewby;
        if(vm.viewby == null){
            vm.generalchart();
        } else if (vm.viewby == 'Company'){
            vm.loadCompanies();
        } else if (vm.viewby == 'Department'){
            vm.loadDepartments();
        } else if (vm.viewby == 'Branch') {
            vm.loadBranches();
        } else if (vm.viewby == 'Section') {
            vm.loadSections();
        }
    },
    
}
</script>

<style scoped>
.se-main-card {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #E8EDF5;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 20px 28px 32px;
  margin-top: 4px;
  overflow-y: auto;
  max-height: calc(100vh - 100px);
}

.textBlue {
    color:  #004080;
}
</style>